export default function() {
  $(() => {
    $('[data-email-capture]').each((_, input) => {
      const $form = $(input)

      function handleResponse(event: any, status: any, xhr: any) {
        let json
        try {
          if (event.detail) {
            json = JSON.parse(event.detail[2].response)
            status = event.detail[1]
          } else {
            json = xhr.responseJSON
          }
        } catch (ex) {
          json = {
            errors: 'An unexpected error occurred!  Please try again later.',
          }
        }

        if ($form.find('.errors')) {
          $form.find('.errors').remove()
        }

        $form.append(
          $('<div>').text(json.errors).addClass('errors'),
        )

        if (!json.errors) {
          $form.find('input[type="email"]').val('')
          $form.find('input[type="email"]').replaceWith(`<span id ="success">${json.message}</span>`)
          $form.find('button[type="submit"]').remove()
          $form.find('span').addClass('form-control rounded-0 pl-4 py-3 h-100')
        }

        if (json.errors) {
          $form.find('input[type="email"], button[type="submit"]').addClass('error-border')
        }
      }

      $form.on('ajax:success', (event, data, status, xhr) => {
        handleResponse(event, status, xhr)
      })

      $form.on('ajax:error', (event, xhr, status) => {
        handleResponse(event, status, xhr)
      })
    })
  })
}
